module.exports = __webpack_public_path__ + "static/media/irori_sm1.f47b6c7c.gif";